<script lang="ts">
    import type { Section } from '../../types/Section'
    import type { State } from '../../types/State'
    import { Formatter } from '../../util/Formatter'
    import Subsection from './Subsection.svelte'

    export let path: [number, number]

    export let state: State

    export let section: Section

    export let simpleLanguage = false
</script>

{#if simpleLanguage}
    <h3>
        <span>{path[1] + 1}</span>
        {@html Formatter.convertLineBreaksToHTML(section.description)}
    </h3>
{:else}
    <h3>
        <span>{path.map((it) => it + 1).join('.')}</span>
        {@html Formatter.convertLineBreaksToHTML(section.description)}
    </h3>
{/if}
{#each section.subsections as subsection, index}
    <Subsection {simpleLanguage} bind:subsection path={[...path, index]} bind:state />
{/each}

<style lang="scss">
    h3 {
        display: flex;
        column-gap: 1rem;
        max-width: 62.5rem;
        font-size: 1.25rem;
        font-weight: 600;

        @media (min-width: 790px) {
            font-size: 2rem;
        }

        span {
            color: var(--color-primary);
        }
    }
</style>
